import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import $ from "jquery";
import { Formik, ErrorMessage, useFormik, FormikProvider, Field, FieldArray, } from "formik";
import { CardBody, CardHeader } from "reactstrap";
import * as Yup from "yup";
import React, { useState, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { datepicker } from "react";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Form, FormControl, FormGroup, FormLabel, Row, Col, Table, Button, } from "react-bootstrap";
import moment from "moment-timezone";
import jsPDF from "jspdf";
import { FaFastBackward, FaFileExcel } from "react-icons/fa";
import { MdOutlinePictureAsPdf, MdPictureAsPdf } from "react-icons/md";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { AiOutlineSearch } from "react-icons/ai";
import { Link } from "react-router-dom";
import { store } from "../../../App";

const Expenditure = () => {
  const [saveDistCode, setSaveDistCode] = useState("")
  const [tableenable, settableenable] = useState(false);
  const [headstableenable, setheadstableenable] = useState(false);
  const [tableData, settabledata] = useState();
  const [HeadstableData, setHeadstabledata] = useState();
  const [PaymenttableData, setPaymenttabledata] = useState();
  const [paymenttableenable, setpaymentableenable] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const Recordsperpage = 100;
  const lastindex = currentPage * Recordsperpage;
  const firstindex = lastindex - Recordsperpage;
  const records = tableData?.slice(firstindex, lastindex);
  const npage = Math.ceil(tableData?.length / Recordsperpage);
  const numbers = Array.from({ length: npage }, (e, index) => index + 1);
  const startSerialNumber = firstindex + 1;
  const [search, setSearch] = useState("");
  const history = useHistory();
  React.useEffect(() => { }, []);
  const todayDate = new Date();
  const [loading, setLoading] = useState(false);

  let year = todayDate.getUTCFullYear();

  let month = todayDate.getMonth() + 1;

  let tDate = todayDate.getDate();

  if (month < 10) {
    month = "0" + month;
  }
  if (tDate < 10) {
    tDate = "0" + tDate;
  }

  const maxDate = year + "-" + month + "-" + tDate;

  const loginUser = localStorage.getItem("username");
  console.log("loginUser:", loginUser)

  const filteredData =
    searchText.length > 0
      ? tableData?.filter((item) => {
        return (
          item &&
          Object.keys(item).some((key) => {
            const value = item[key];
            return (
              value !== null &&
              value
                .toString()
                .toLowerCase()
                .includes(searchText.toLowerCase())
            );
          })
        );
      })
      : records;

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const firstDayOfMonth = `${currentYear}-${currentMonth
    .toString()
    .padStart(2, "0")}-01`;

  const formik = useFormik({
    initialValues: {
      fromDate: firstDayOfMonth,
      toDate: today.toISOString().substr(0, 10),
    },
    validate: (values) => {
      const errors = {};

      if (!values.fromDate) {
        errors.fromDate = "From Date is required";
      }

      if (!values.toDate) {
        errors.toDate = "To Date is required";
      }
      if (values.fromDate && values.toDate && values.fromDate > values.toDate) {
        errors.toDate = "To Date must be greater than From Date";
      }
      return errors;
    },

    onSubmit: async (values) => {
      let params = {
        fromDate: moment(values.fromDate).format("DD/MM/YYYY"),
        toDate: moment(values.toDate).format("DD/MM/YYYY"),
      };
      setLoading(true);
      store.dispatch({ type: "SHOW_SPINNER" });
      await new Promise((resolve) => setTimeout(resolve, 2000));
      HousingService.GetExpenditureAnalaysis_Report(params).then((res) => {
        settabledata(res.data);
        store.dispatch({ type: "HIDE_SPINNER" });
        $(function () {
          function tally(selector) {
            $(selector).each(function () {
              var total = 0,
                column = $(this).siblings(selector).addBack().index(this);
              $("#my-table tbody tr").each(function () {
                total +=
                  parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
              });
              $(this).html(total);
            });
          }
          tally("td.total");
        });
      });

      setheadstableenable(false);
      setLoading(false);
      setpaymentableenable(false);
      settableenable(true);
    },
  });

  function generateExpenditurePdf() {
    const pageWidth = 500; // Example: 210mm for A4 size
    const pageHeight = 297; // Example: 297mm for A4 size

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [pageWidth, pageHeight],
    });

    const imgPath = "/img/APSHCL_logo.png"; // Note the leading slash to reference the public folder

    const fromDate = moment(formik.values.fromDate).format("DD/MM/YYYY");
    const toDate = moment(formik.values.toDate).format("DD/MM/YYYY");
    const distuser = localStorage.getItem("username");
    const headingText2 =
      "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
    const headingText4 =
      "Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007";

    const headingText3 = `Expenditure Analysis between : ${fromDate} to : ${toDate} User: ${distuser}`;

    const fontSize = 12;

    doc.setFont("times new roman");
    doc.setFontSize(fontSize);

    const textWidth2 =
      (doc.getStringUnitWidth(headingText2) * fontSize) /
      doc.internal.scaleFactor;
    const textWidth3 =
      (doc.getStringUnitWidth(headingText3) * fontSize) /
      doc.internal.scaleFactor;
    const textWidth4 =
      (doc.getStringUnitWidth(headingText4) * fontSize) /
      doc.internal.scaleFactor;
    const tableYStart = 40;

    const xCoordinate2 = (pageWidth * 1 - textWidth2) / 2;
    const xCoordinate3 = (pageWidth * 1 - textWidth3) / 2;
    const xCoordinate4 = (pageWidth * 1 - textWidth4) / 2;
    doc.text(headingText2, xCoordinate2, 10); // Adjust the Y-coordinate (e.g., 10) as needed
    doc.text(headingText3, xCoordinate3, 35); // Adjust the Y-coordinate (e.g., 35) as needed
    doc.text(headingText4, xCoordinate4, 20); // Adjust the Y-coordinate (e.g., 20) as needed

    // Add the image to the PDF at the top-left corner
    doc.addImage(imgPath, "PNG", 7, 7, 25, 25); // Adjust the size as needed

    doc.autoTable({
      html: "#my-generateExpenditurePdf",
      theme: "grid",
      tableWidth: "auto",
      columnStyles: {
        3: { cellWidth: "wrap" },
      },
      startY: tableYStart,
      margin: { top: 10, right: 15, bottom: 10, left: 15 },
      styles: {
        fontSize: 8,
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 },
    });

    doc.save("Expenditure.pdf");
  }

  function generatePaymentsExpenditurePdf() {
    const pageWidth = 600; // Example: 210mm for A4 size
    const pageHeight = 300; // Example: 297mm for A4 size

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [pageWidth, pageHeight],
    });

    const imgPath = "/img/APSHCL_logo.png"; // Note the leading slash to reference the public folder

    const fromDate = moment(formik.values.fromDate).format("DD/MM/YYYY");
    const toDate = moment(formik.values.toDate).format("DD/MM/YYYY");
    const distuser = localStorage.getItem("username");
    const headingText2 =
      "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
    const headingText4 =
      "Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007";

    const headingText3 = `Expenditure Analysis Report between : ${fromDate} to : ${toDate} User: ${distuser}`;

    const fontSize = 12;

    doc.setFont("times new roman");
    doc.setFontSize(fontSize);

    const textWidth2 =
      (doc.getStringUnitWidth(headingText2) * fontSize) /
      doc.internal.scaleFactor;
    const textWidth3 =
      (doc.getStringUnitWidth(headingText3) * fontSize) /
      doc.internal.scaleFactor;
    const textWidth4 =
      (doc.getStringUnitWidth(headingText4) * fontSize) /
      doc.internal.scaleFactor;
    const tableYStart = 40;

    const xCoordinate2 = (pageWidth * 1 - textWidth2) / 2;
    const xCoordinate3 = (pageWidth * 1 - textWidth3) / 2;
    const xCoordinate4 = (pageWidth * 1 - textWidth4) / 2;
    doc.text(headingText2, xCoordinate2, 10); // Adjust the Y-coordinate (e.g., 10) as needed
    doc.text(headingText3, xCoordinate3, 35); // Adjust the Y-coordinate (e.g., 35) as needed
    doc.text(headingText4, xCoordinate4, 20); // Adjust the Y-coordinate (e.g., 20) as needed

    // Add the image to the PDF at the top-left corner
    doc.addImage(imgPath, "PNG", 7, 7, 25, 25); // Adjust the size as needed

    doc.autoTable({
      html: "#my-generatePaymentsExpenditurePdf ",
      theme: "grid",
      tableWidth: "auto",
      columnStyles: {
        3: { cellWidth: "wrap" },
      },
      startY: tableYStart,
      margin: { top: 10, right: 15, bottom: 10, left: 15 },
      styles: {
        fontSize: 8,
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 },
    });

    doc.save("TransactionExpenditure.pdf");
  }
  const [Heading, setHeading] = useState();
  function getOnClick(classification, code, head) {
    setSaveDistCode(code)
    setHeading(head);
    const params = {
      code: code,
      classification: classification,
      fromDate: moment(formik.values.fromDate).format("DD/MM/YYYY"),
      toDate: moment(formik.values.toDate).format("DD/MM/YYYY"),
    };
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.GetExpenditureAnalaysis_OnClick_Exp(params).then((res) => {
      setHeadstabledata(res.data);
      store.dispatch({ type: "HIDE_SPINNER" });
      settableenable(false);
      setheadstableenable(true);
    });
  }
  function getTotal(classification, code, head) {
    setHeading(head);
    const params = {
      // code: code,
      classification: classification,
      fromDate: moment(formik.values.fromDate).format("DD/MM/YYYY"),
      toDate: moment(formik.values.toDate).format("DD/MM/YYYY"),
    };
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.GetExpenditureAnalaysis_OnClick_Exp_all(params).then(
      (res) => {
        setHeadstabledata(res.data);
        store.dispatch({ type: "HIDE_SPINNER" });
        settableenable(false);
        setheadstableenable(true);
      }
    );
  }
  function getOnClick_Headid(headid, classification) {
    const params = {
      headid: headid,
      code: saveDistCode,
      classification: classification,
      fromDate: moment(formik.values.fromDate).format("DD/MM/YYYY"),
      toDate: moment(formik.values.toDate).format("DD/MM/YYYY"),
    };
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.GetExpenditureAnalaysis_OnClick_Headid(params).then(
      (res) => {
        setPaymenttabledata(res.data);
        store.dispatch({ type: "HIDE_SPINNER" });
        settableenable(false);
        setheadstableenable(false);
        setpaymentableenable(true);
      }
    );
  }
  const getPdf = (payment_receipt_id) => {
    HousingService.ReceiptEntryPdf(payment_receipt_id).then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );

      let tab = window.open();

      tab.location.href = url;
    });
  };
  const goBackTo = () => {
    setheadstableenable(false);
    setheadstableenable(false);
    settableenable(true);
  };
  const goBackToHeads = () => {
    setpaymentableenable(false);
    settableenable(false);
    setheadstableenable(true);
  };
  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container fluid style={{ width: "90%" }}>
        <OFMSUI.Row>
          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="page-titlespacing"
          >
            <div className="inner-herbpage-service-title1">

              <h1 style={{ marginLeft: "-15px" }}>Expenditure Analysis Report</h1>
            </div>
          </OFMSUI.Col>

          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="page-titlespacing"
          >
            <button
              className="btn btn-primary btn-sm"
              style={{
                textAlign: "right",
                float: "right",
                marginTop: "30px",
                backgroundColor: "#603913",
                borderColor: "#603913",
                color: "#fff",
              }}
              type="reset"
              onClick={() => history.goBack()}
            >
              <FaFastBackward /> &nbsp;Back
            </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container
        className="outer-page-content-container"
        fluid
        style={{ width: "90%" }}
      >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={3}
                xl={3}
                xxl={3}
              ></OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <th>

                  From Date:
                  <span className="mandatory" style={{ color: "red" }}>

                    *
                  </span>
                </th>
                <Field
                  name="fromDate"
                  className={
                    formik.touched.fromDate && formik.errors.fromDate
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  type="date"
                  onChange={(e) => formik.handleChange(e)}
                  max={maxDate}
                />
                {formik.touched.fromDate && formik.errors.fromDate ? (
                  <div className="invalid-feedback">

                    {formik.errors.fromDate}
                  </div>
                ) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <th>

                  To Date:
                  <span className="mandatory" style={{ color: "red" }}>

                    *
                  </span>
                </th>
                <Field
                  name="toDate"
                  className={
                    formik.touched.toDate && formik.errors.toDate
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  type="date"
                  onChange={(e) => formik.handleChange(e)}
                  max={maxDate}
                />
                {formik.touched.toDate && formik.errors.toDate ? (
                  <div className="invalid-feedback">{formik.errors.toDate}</div>
                ) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                <center>

                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    style={{
                      marginTop: "30px",
                      backgroundColor: "#603913",
                      borderColor: "#603913",
                      color: "#fff",
                    }}
                  >
                    Submit
                  </button>
                </center>
              </OFMSUI.Col>
            </OFMSUI.Row>
            &nbsp;
            <OFMSUI.Row>

              {tableenable && (
                <>
                  <OFMSUI.Row>
                    <OFMSUI.Col className=" mb-2 float-end">
                      <button type="button" className="btn btn-success btn-sm" style={{ float: "right", color: "#fff" }} >
                        <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className="download-table-xls-button"
                          table="my-generateExpenditurePdf"
                          filename="Expenditure"
                          sheet="tablexls"
                          buttonText="Excel"
                        ></ReactHTMLTableToExcel>
                      </button>
                      <button className="btn btn-danger btn-sm" onClick={generateExpenditurePdf} style={{ float: "right", marginLeft: "3px" }} type="button" >
                        PDF <MdOutlinePictureAsPdf />
                      </button>
                    </OFMSUI.Col>
                  </OFMSUI.Row>

                  <OFMSUI.Table
                    striped
                    bordered
                    hover
                    id="my-generateExpenditurePdf"
                  >
                    <thead style={{ position: "sticky", top: "0px" }}>
                      <tr>

                        <td colSpan={19} style={{ textAlign: "center" }}>

                          Expenditure Analysis Report between &nbsp;
                          {moment(formik.values.fromDate).format(
                            "DD-MM-YYYY"
                          )} &nbsp;
                          and &nbsp;
                          {moment(formik.values.toDate).format("DD-MM-YYYY")}
                          &nbsp;
                        </td>
                      </tr>
                      <tr className="table_countshead">
                        <th>S No.</th> <th> District Name</th>
                        <th
                          colSpan={2}
                          title="20101-SALARIES TO STAFF
20104-MEDICAL ALLOWNACE
20106-CONVEYANCE ALLOWNACE
20107-EX-GRATIA
20108-WAGES TO NMR
20110-HONORARIUM TO CHAIRMAN AND DIRECTOR
20112-REMMUNERATION TO OUTSOURCING STAFF
20501-EDUCATIONAL ALLOWANCE
20502-LEAVE SALARY CONTRIBUTION
20503-PENSION AND CONTRIBUTION
20504-AWARDS AND INCENTIVES
20508-LIVERY TO STAFF
20623-SECURITY CHARGES
21301-EMPLOYER EPF CONTRIBUTION
21303-ADMIN CHARGES ON EPF/FPF
21304-EDLIS CHARGES
21305-ADMIN CHARGES ON EDLIS 
"
                        >
                          Salaries and Wages
                        </th>
                        <th
                          colSpan={2}
                          title="
                        20605-INSURANCE-VEHICLES
                        20620-HIRE CHARGERS -VEHICLES
                        20634-POL CHARGERS
                        20635-REPAIRS AND MAINTAINACE-VEHICLES"
                        >
                          Conveyance
                        </th>
                        <th
                          colSpan={2}
                          title="20203-GODOWN RENT
20204-TRANSPORTATION CHARGES
20401-GRATUITY
20505-LTC TO STAFF
20601-RENT
20602-RATES AND TAXES
20603-WATER CHARGES
20606-ELECTRICITY CHARGES
20607-PRINTING AND STATIONARY
20608-POSTAGE
20609-TELEGRAMS
20610-TELEPHONES
20611-INTERNET CHARGES
20612-TRAVELLING EXPENSES-STAFF
20615-ADVERTISEMENT CHARGERS
20618-LEGAL CHARGERS
20621-RECRUITMENT AND TRAINING COST"
                        >
                          Administrative
                        </th>
                        <th
                          colSpan={2}
                          title="20206-INSTITUTIONAL CHARGES-ZMS
20207-INSTITUTIONAL CHARGES-VOS/SHGS
20208-SERVICE CHARGES TO SERVICE PROVIDERS
20599-OTHER CONTRIBUTION
20622-DONATIONS
20637-PROFESSIONAL CHARGES
20639-SOFTWARE DEVELOPMENT CHARGES
20642-AUDIT FEE
20645-INAUGURAL EXPENSES
20646-COLOURING EXPENSES
20699-MISCELLANEOUS EXPENDITURE"
                        >
                          Others
                        </th>
                        <th colSpan={2}> Total</th>
                        <th
                          colSpan={2}
                          title="40101-LAND
40102-BUILDINGS
40103-PLANT AND MACHINERY
40104-OFFICE AND OTHER EQUIPMENT
40105-FURNTITURE AND FIXTURES
40106-ELECTRICAL EQUIPMENT
40107-VEHICLES
40109-BICYCLES
40110-COMPUTERS"
                        >

                          Capital Exp.
                        </th>
                        <th
                          colSpan={2}
                          title="41001_FESTIVAL ADAVNCE
41002-EDUCATIONAL ADVANCE
41003-CYCLE-ADVANCE
41004-MOTOR CAR / CYCLE ADAVANCE
41005-HOUSE BUILDING ADVANCE'
41006-TOUR ADVANCE
41007-L.T.C ADVANCE
41008-SALARY ADAVANCE
41009-MISC STAFF ADVANCE
41010-SPECIAL FESTIVAL ADVANCE
41011-MARRAIAGE ADVANCE
41013-MEDICAL ADVANCE
41014-COMPUTER ADVANCE
"
                        >
                          Advance to Staff
                        </th>
                        <th
                          colSpan={2}
                          title="31301 - OTHER LIABILITIES
31701 - SALARIES PAYABLE 
31702 - REMUNERATION TO OUTSOURCING STAFF PAYABLE 
31703 - WAGES TO NMR PAYABLE 
34401 - GPF PAYABLE 3
4402 - GPF LOAN PAYABLE 
34403 - APGLI PAYABLE 
34405 - GIC PAYABLE 
34406 - EPF PAYABLE 
34412 - LIC PAYABLE 
34414 - POSTAL SAVINGS PAYABLE 
34415 - PROFESSIONAL TAX PAYABLE 
34416 - DEDUCTIONS - OTHER AGENCIES PAYABLE 
34417 - CMS RELEF FUND PAYABLE 
34419 - HCESA PAYABLE 
34420 - STAFF PERSONAL LOANS PAYABLE 
34424 - EMPLOYEES RELEIF FUND PAYABLE 
34425 - APSG EMPLOYEES WELFARE FUND PAYABLE 
34426 - GSLI PAYABLE 
34428 - CTD RECOVERIES PAYABLE 
34429 - ARMY WELFARE FUND PAYABLE 
34431 - FLAG DAY FUND PAYABLE 
34432 - PMS RELEIF FUND PAYABLE"
                        >

                          Recoveries/ Liabilities
                        </th>
                      </tr>

                      <tr className="table_countshead">
                        <th></th>
                        <th></th>
                        <th> Allot (in Lakhs)</th>
                        <th> Exp. (in Rs)</th>
                        <th> Allot (in Lakhs)</th>
                        <th> Exp. (in Rs)</th>
                        <th> Allot (in Lakhs)</th>
                        <th> Exp. (in Rs)</th>
                        <th> Allot (in Lakhs)</th>
                        <th> Exp. (in Rs)</th>
                        <th> Allot (in Lakhs)</th>
                        <th> Exp. (in Rs)</th>
                        <th> Allot (in Lakhs)</th>
                        <th> Exp. (in Rs)</th>
                        <th> Allot (in Lakhs)</th>
                        <th> Exp. (in Rs)</th>
                        <th>Dr/Cr </th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData
                        ?.filter((element) =>
                          element.name
                            .toLowerCase()
                            .includes(search.toLowerCase())
                        )
                        .map((tableData, i) => (
                          <tr key={i} style={{ textAlign: "right" }}>
                            <td style={{ textAlign: "center", width: "50px" }}>

                              {startSerialNumber + i}
                            </td>

                            <td style={{ width: "200px", textAlign: "left" }}>
                              {tableData.name}
                            </td>

                            <td style={{ width: "100px" }}>

                              {tableData.regular}
                            </td>

                            <td
                              style={{ width: "170px" }}
                              onClick={() =>
                                getOnClick(
                                  "01",
                                  tableData.code,
                                  "Salary and Wages"
                                )
                              }
                            >

                              <Link>{tableData.reg_exp}</Link>
                            </td>

                            <td style={{ width: "100px" }}>

                              {tableData.conveyance}
                            </td>

                            <td
                              style={{ width: "170px" }}
                              onClick={() =>
                                getOnClick("02", tableData.code, "Conveyance")
                              }
                            >

                              <Link>{tableData.conveyance_exp}</Link>
                            </td>

                            <td style={{ width: "100px" }}>

                              {tableData.administative}
                            </td>

                            <td
                              style={{ width: "170px" }}
                              onClick={() =>
                                getOnClick(
                                  "03",
                                  tableData.code,
                                  "Administrative"
                                )
                              }
                            >

                              <Link>{tableData.administative_exp}</Link>
                            </td>

                            <td style={{ width: "100px" }}>

                              {tableData.others}
                            </td>

                            <td
                              style={{ width: "170px" }}
                              onClick={() =>
                                getOnClick("05", tableData.code, "Others")
                              }
                            >

                              <Link>{tableData.others_exp}</Link>
                            </td>

                            <td style={{ width: "100px" }}>{tableData.tot}</td>

                            <td style={{ width: "170px" }}>

                              {tableData.tot_exp}
                            </td>

                            <td style={{ width: "100px" }}>

                              {tableData.capital_exp}
                            </td>

                            <td
                              style={{ width: "170px" }}
                              onClick={() =>
                                getOnClick("04", tableData.code, "Capital Exp")
                              }
                            >

                              <Link>{tableData.capital_expenditure}</Link>
                            </td>

                            <td style={{ width: "100px" }}>

                              {tableData.adv_staff}
                            </td>

                            <td
                              style={{ width: "170px" }}
                              onClick={() =>
                                getOnClick(
                                  "07",
                                  tableData.code,
                                  "Adavance Staff"
                                )
                              }
                            >

                              <Link>{tableData.advance_exp}</Link>
                            </td>

                            <td>

                              <span
                                style={{
                                  color:
                                    tableData.dr_cr === "CR" ? "green" : "red",
                                }}
                              >

                                {tableData.dr_cr}
                              </span>
                            </td>

                            <td
                              style={{ width: "170px" }}
                              onClick={() =>
                                getOnClick("08", tableData.code, "Liabilities")
                              }
                            >

                              <Link>{tableData.liabilities_amount}</Link>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                    <tfoot>
                      <tr style={{ textAlign: "right" }}>
                        <td colSpan={2}>Grand Total </td>

                        {/* Regular */}
                        <td>
                          {tableData
                            ?.reduce((a, v) => a + parseFloat(v.regular), 0)
                            .toFixed(2)}
                        </td>

                        {/* Salary & Wages */}
                        <td>
                          {loginUser === "APSHCL" ? (
                            <Link onClick={() => getTotal("01", tableData.code, "Salary and Wages")}>
                              {tableData
                                ?.reduce((a, v) => a + parseFloat(v.reg_exp), 0)
                                .toFixed(2)}
                            </Link>
                          ) : (
                            tableData
                              ?.reduce((a, v) => a + parseFloat(v.reg_exp), 0)
                              .toFixed(2)
                          )}
                        </td>

                        {/* Conveyance */}
                        <td>
                          {tableData
                            ?.reduce((a, v) => a + parseFloat(v.conveyance), 0)
                            .toFixed(2)}
                        </td>

                        <td>
                          {loginUser === "APSHCL" ? (
                            <Link onClick={() => getTotal("02", tableData.code, "Conveyance")}>
                              {tableData
                                ?.reduce((a, v) => a + parseFloat(v.conveyance_exp), 0)
                                .toFixed(2)}
                            </Link>
                          ) : (
                            tableData
                              ?.reduce((a, v) => a + parseFloat(v.conveyance_exp), 0)
                              .toFixed(2)
                          )}
                        </td>

                        {/* Administrative */}
                        <td>
                          {tableData
                            ?.reduce((a, v) => a + parseFloat(v.administative), 0)
                            .toFixed(2)}
                        </td>

                        <td>
                          {loginUser === "APSHCL" ? (
                            <Link onClick={() => getTotal("03", tableData.code, "Administrative")}>
                              {tableData
                                ?.reduce((a, v) => a + parseFloat(v.administative_exp), 0)
                                .toFixed(2)}
                            </Link>
                          ) : (
                            tableData
                              ?.reduce((a, v) => a + parseFloat(v.administative_exp), 0)
                              .toFixed(2)
                          )}
                        </td>

                        {/* Others */}
                        <td>
                          {tableData
                            ?.reduce((a, v) => a + parseFloat(v.others), 0)
                            .toFixed(2)}
                        </td>

                        <td>
                          {loginUser === "APSHCL" ? (
                            <Link onClick={() => getTotal("05", tableData.code, "Others")}>
                              {tableData
                                ?.reduce((a, v) => a + parseFloat(v.others_exp), 0)
                                .toFixed(2)}
                            </Link>
                          ) : (
                            tableData
                              ?.reduce((a, v) => a + parseFloat(v.others_exp), 0)
                              .toFixed(2)
                          )}
                        </td>

                        {/* Total */}
                        <td>
                          {tableData
                            ?.reduce((a, v) => a + parseFloat(v.tot), 0)
                            .toFixed(2)}
                        </td>

                        <td>
                          {tableData
                            ?.reduce((a, v) => a + parseFloat(v.tot_exp), 0)
                            .toFixed(2)}
                        </td>

                        {/* Capital Exp */}
                        <td>
                          {tableData
                            ?.reduce((a, v) => a + parseFloat(v.capital_exp), 0)
                            .toFixed(2)}
                        </td>

                        <td>
                          {loginUser === "APSHCL" ? (
                            <Link onClick={() => getTotal("04", tableData.code, "Capital Exp")}>
                              {tableData
                                ?.reduce((a, v) => a + parseFloat(v.capital_expenditure), 0)
                                .toFixed(2)}
                            </Link>
                          ) : (
                            tableData
                              ?.reduce((a, v) => a + parseFloat(v.capital_expenditure), 0)
                              .toFixed(2)
                          )}
                        </td>

                        {/* Advance Staff */}
                        <td>
                          {tableData
                            ?.reduce((a, v) => a + parseFloat(v.adv_staff), 0)
                            .toFixed(2)}
                        </td>

                        <td>
                          {loginUser === "APSHCL" ? (
                            <Link onClick={() => getTotal("07", tableData.code, "Adavance Staff")}>
                              {tableData
                                ?.reduce((a, v) => a + parseFloat(v.advance_exp), 0)
                                .toFixed(2)}
                            </Link>
                          ) : (
                            tableData
                              ?.reduce((a, v) => a + parseFloat(v.advance_exp), 0)
                              .toFixed(2)
                          )}
                        </td>

                        {/* Empty Cell */}
                        <td></td>

                        {/* Liabilities */}
                        <td>
                          {loginUser === "APSHCL" ? (
                            <Link onClick={() => getTotal("08", tableData.code, "Liabilities")}>
                              {tableData
                                ?.reduce((a, v) => a + parseFloat(v.liabilities_amount), 0)
                                .toFixed(2)}
                            </Link>
                          ) : (
                            tableData
                              ?.reduce((a, v) => a + parseFloat(v.liabilities_amount), 0)
                              .toFixed(2)
                          )}
                        </td>
                      </tr>
                    </tfoot>

                  </OFMSUI.Table>
                </>
              )}
              {headstableenable && (
                <>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                    <button
                      className="btn btn-primary btn-sm"
                      style={{
                        textAlign: "left",
                        float: "left",
                        marginTop: "20px",
                      }}
                      type="button"
                      onClick={() => goBackTo()}
                    >
                      <FaFastBackward /> &nbsp;Back
                    </button>
                  </OFMSUI.Col>
                  <OFMSUI.Col className=" mb-2 float-end">
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      style={{ float: "right", color: "#fff" }}
                    >
                      <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-table-xls-button"
                        table="my-generateHeadsExpenditurePdf"
                        filename="Expenditure"
                        sheet="tablexls"
                        buttonText="Excel"
                      ></ReactHTMLTableToExcel>
                    </button>
                  </OFMSUI.Col>
                  &nbsp;
                  <Table
                    striped
                    bordered
                    hover
                    id="my-generateHeadsExpenditurePdf"
                  >
                    <thead className="fw-bold">
                      <tr>

                        <td colSpan={12} style={{ textAlign: "center" }}>

                          {localStorage.getItem("username")} Expenditure
                          Analysis For {Heading}&nbsp; between &nbsp;
                          {moment(formik.values.fromDate).format("DD-MM-YYYY")}
                          &nbsp; and &nbsp;
                          {moment(formik.values.toDate).format("DD-MM-YYYY")}
                        </td>
                      </tr>
                      <tr className="table_countshead">
                        <th>S No.</th>
                        <th>Headid</th>
                        <th> HeadName</th>
                        <th>Debit</th>
                        <th>Credit</th>
                        <th> Dr/Cr</th>
                        <th> Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {HeadstableData && HeadstableData.length > 0 ? (
                        HeadstableData.map((data, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td style={{ width: "170px" }} onClick={() => getOnClick_Headid(data.headid, data.classification)} >  <Link>{data.headid}</Link> </td>
                            <td>{data.headname}</td> <td>{data.debit}</td> <td>{data.cr_amount}</td>
                            <td>

                              <span
                                style={{
                                  color: data.dr_cr === "CR" ? "green" : "red",
                                }}
                              >

                                {data.dr_cr}
                              </span>
                            </td>
                            <td>{data.amount}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>

                          <td
                            colSpan="6"
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >

                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: "0px" }}>
                      <tr className="table_countshead">
                        <td colSpan={3} style={{ textAlign: "end" }}>

                          Total Amount in Rs
                        </td>
                        <td>

                          {HeadstableData?.reduce(
                            (a, v) => a + v.debit,
                            0
                          ).toLocaleString("en-IN")}
                        </td>
                        <td>

                          {HeadstableData?.reduce(
                            (a, v) => a + v.cr_amount,
                            0
                          ).toLocaleString("en-IN")}
                        </td>
                        <td></td>
                        <td>

                          {HeadstableData?.reduce(
                            (a, v) => a + v.amount,
                            0
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                </>
              )}
              {paymenttableenable && (
                <>
                  <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                      <button
                        className="btn btn-primary btn-sm"
                        style={{
                          textAlign: "left",
                          float: "left",
                          marginTop: "20px",
                        }}
                        type="button"
                        onClick={() => goBackToHeads()}
                      >

                        <FaFastBackward /> &nbsp;Back
                      </button>
                    </OFMSUI.Col>
                    <OFMSUI.Col className=" mb-2 float-end">
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        style={{ float: "right", color: "#fff" }}
                      >
                        <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className="download-table-xls-button"
                          table="my-generatePaymentsExpenditurePdf"
                          filename="Expenditure"
                          sheet="tablexls"
                          buttonText="Excel"
                        ></ReactHTMLTableToExcel>
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={generatePaymentsExpenditurePdf}
                        style={{ float: "right", marginLeft: "3px" }}
                      >

                        PDF <MdOutlinePictureAsPdf />
                      </button>
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                  &nbsp;
                  <Table
                    striped
                    bordered
                    hover
                    id="my-generatePaymentsExpenditurePdf"
                  >
                    <thead className="fw-bold">
                      <tr>
                        <td colSpan={8} style={{ textAlign: "center" }}>

                          {localStorage.getItem("username")} Expenditure
                          Analysis For {Heading}&nbsp; between &nbsp;
                          {moment(formik.values.fromDate).format("DD-MM-YYYY")}
                          &nbsp; and &nbsp;
                          {moment(formik.values.toDate).format("DD-MM-YYYY")}
                        </td>
                      </tr>
                      <tr className="table_countshead">
                        {/* VoucherNo.	 */}
                        <th>Sl.No</th>
                        <th>Transaction Id</th>
                        <th>Date</th>
                        <th> Description</th>
                        <th>Debit</th>
                        <th>Credit</th>
                        <th> Dr/Cr</th>
                        <th> Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {PaymenttableData && PaymenttableData.length > 0 ? (
                        PaymenttableData.map((data, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td
                              style={{ width: "170px" }}
                              onClick={() => getPdf(data.payment_receipt_id)}
                            >

                              <Link>{data.payment_receipt_id}</Link>
                            </td>
                            <td>{data.date}</td>
                            <td>{data.receipt_description}</td>
                            <td>{data.debit}</td>
                            <td>{data.credit}</td>
                            <td>

                              <span
                                style={{
                                  color: data.dr_cr === "CR" ? "green" : "red",
                                }}
                              >

                                {data.dr_cr}
                              </span>
                            </td>
                            <td>{data.amount}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>

                          <td
                            colSpan="6"
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >

                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: "0px" }}>
                      <tr className="table_countshead">
                        <td colSpan={4} style={{ textAlign: "end" }}>

                          Total Amount in Rs
                        </td>
                        <td>

                          {PaymenttableData?.reduce(
                            (a, v) => a + v.debit,
                            0
                          ).toLocaleString("en-IN")}
                        </td>
                        <td>

                          {PaymenttableData?.reduce(
                            (a, v) => a + v.credit,
                            0
                          ).toLocaleString("en-IN")}
                        </td>
                        <td></td>
                        <td>

                          {PaymenttableData?.reduce(
                            (a, v) => a + v.amount,
                            0
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                </>
              )}
            </OFMSUI.Row>
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
};
export default Expenditure;
